import { Button, Form, Col, Offcanvas, Card, Row } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import { BsEye, BsEyeSlash } from "react-icons/bs";
import WebService from "../../../utility/WebService";
import { Label } from "../../../components/Label/Label";
import HelperService from "../../../utility/HelperService";
import { EMAIL_REGEX } from "../../../utility/constants";
import Select from 'react-select';
import { Trash } from "react-bootstrap-icons";
import { Link, useNavigate } from "react-router-dom";
import routePaths from "../../../Navigation/routePaths";

interface PropData {
    isShow: boolean;
    isClose: Function;
    data: any;
}

interface formInterface {
    id: string;
    uuid: string;
    first_name: string;
    last_name: string;
    email: string;
    password: string;
    phone: number;
    comfirm_password: string;
    projects_id: string[];
    role: number;
}

const AddUser = (props: PropData) => {
    const navigate = useNavigate();
    const { handleSubmit, formState: { errors }, control, watch, getValues, register, reset, setValue } = useForm<formInterface>({});
    const watchAllFields = watch();
    const passwordRegex = /^^(?=.*[A-Za-z0-9])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,20}$/;
    const [isShowNewPassword, setIsShowNewPassword] = useState<boolean>(false);
    const [isShowConfirmPassword, setIsShowConfirmPassword] = useState<boolean>(false);
    const [isEdit, setIsEdit] = useState<boolean>(false);
    const [projectOptions, setProjectOptions] = useState<any[]>([]);
    const [roleOptions, setRoleOptions] = useState<any[]>([]);

    useEffect(() => {
        if (props.isShow) {
            if (props.data && !HelperService.isEmptyObject(props.data)) {
                reset(props.data);
                setValue('projects_id', props.data.projects);
                setValue('role', props.data.role_id);
                setIsEdit(true);
            } else {
                reset({});
                resetForm();
                setIsEdit(false);
            }
            !projectOptions.length && getProjectList()
            !roleOptions.length && getRoleList()
        }
    }, [props.isShow, props.data]);

    const handleFormSubmit = (data: formInterface) => {
        data.phone = Number(data.phone.toString().replaceAll("-", ""));
        let project: string[] = [];
        data.projects_id.map((item: any) => {
            project.push(item.value);
        });
        data.projects_id = project;
        const url = isEdit ? `user/update` : "create-user";
        WebService[isEdit ? "putAPI" : 'postAPI']({
            action: url, body: data, id: "changePassword-btn",
        })
            .then((res: any) => {
                toast.success(res.message);
                closeModal(true);
            })
            .catch(() => { });
    };

    const getProjectList = () => {
        WebService.getAPI({
            action: "get/project/list",
        }).then((res: any) => {
            var projectList = res.list.map((item: any) => {
                return { ...item, value: item.id, label: item.project_name };
            });
            setProjectOptions(projectList);
        });
    };

    const getRoleList = () => {
        WebService.getAPI({
            action: "get-role-list",
        }).then((res: any) => {
            var roleList = res.roles.map((item: any) => {
                return { ...item, value: item.id, label: item.role };
            });
            setRoleOptions(roleList);
        });
    };

    // 

    const closeModal = (e: boolean) => {
        reset();
        resetForm();
        props.isClose(e);
    };

    const resetForm = () => {
        setValue('first_name', '');
        setValue('last_name', '');
        setValue('email', '');
        setValue('phone', '' as any);
        setValue('password', '');
        setValue('comfirm_password', '');
        setValue('projects_id', []);
    };

    return (
        <>
            <Offcanvas show={props.isShow} onHide={props.isClose} placement="end" className="offcanvas-large">
                <Offcanvas.Header closeButton><Offcanvas.Title>{isEdit ? "Edit User" : "Add User"}</Offcanvas.Title></Offcanvas.Header>
                <Offcanvas.Body className="form-style">
                    <form className="form-style" onSubmit={handleSubmit(handleFormSubmit)}  >
                        <Row>
                            <Col lg={12} md={6} sm={12} className="mb-3">
                                {/* First Name */}
                                <Controller
                                    control={control}
                                    name="first_name"
                                    rules={{ required: "Please Enter First Name" }}
                                    render={({ field: { onChange, onBlur }, fieldState: { isTouched } }) => (
                                        <div className="mb-2">
                                            <Form.Label>First Name</Form.Label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="First Name"
                                                onChange={onChange}
                                                onBlur={onBlur}
                                                value={watchAllFields.first_name}
                                            />
                                            {(errors["first_name"]?.message || Boolean(errors["first_name"]?.message) || (isTouched && !watchAllFields.first_name)) && (
                                                <div className="login-error">
                                                    <Label title={errors.first_name?.message || "Please Enter First Name."} modeError={true} />
                                                </div>
                                            )}
                                        </div>
                                    )}
                                />

                                {/* Last Name */}
                                <Controller
                                    control={control}
                                    name="last_name"
                                    rules={{ required: "Please Enter Last Name" }}
                                    render={({ field: { onChange, onBlur }, fieldState: { isTouched } }) => (
                                        <div className="mb-2">
                                            <Form.Label>Last Name</Form.Label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Last Name"
                                                onChange={onChange}
                                                onBlur={onBlur}
                                                value={watchAllFields.last_name}
                                            />
                                            {(errors["last_name"]?.message || Boolean(errors["last_name"]?.message) || (isTouched && !watchAllFields.last_name)) && (
                                                <div className="login-error">
                                                    <Label title={errors.last_name?.message || "Please Enter Last Name."} modeError={true} />
                                                </div>
                                            )}
                                        </div>
                                    )}
                                />

                                {/* Email */}
                                <Controller
                                    control={control}
                                    name="email"
                                    rules={{
                                        required: "Please Enter Email",
                                        pattern: {
                                            value: EMAIL_REGEX,
                                            message: "Please Enter Valid Email.",
                                        },
                                    }}
                                    render={({ field: { onChange, onBlur }, fieldState: { isTouched } }) => (
                                        <div className="mb-2">
                                            <Form.Label>Email</Form.Label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Email"
                                                onChange={onChange}
                                                onBlur={onBlur}
                                                value={watchAllFields.email}
                                            />
                                            {(errors["email"]?.message ||
                                                Boolean(errors["email"]?.message) ||
                                                (isTouched && !watchAllFields.email)) && (
                                                    <div className="login-error">
                                                        <Label title={errors.email?.message || "Please Enter Email."} modeError={true} />
                                                    </div>
                                                )}
                                        </div>
                                    )}
                                />

                                {/* Phone */}
                                <Controller
                                    control={control}
                                    name="phone"
                                    rules={{
                                        required: "Please Enter Phone",
                                    }}
                                    render={({ field: { onChange }, fieldState: { isTouched } }) => (
                                        <div className="mb-2">
                                            <Form.Label>Phone</Form.Label>
                                            <input
                                                type="text"
                                                className="form-control ps-3 p-2"
                                                placeholder="Mobile"
                                                onChange={onChange}
                                                onKeyPress={HelperService.allowOnlyNumericValue}
                                                onKeyUp={(e) => HelperService.contactFormatter(e)}
                                                value={watchAllFields.phone}
                                            />
                                            {(errors["phone"]?.message ||
                                                Boolean(errors["phone"]?.message) ||
                                                (isTouched && !watchAllFields.phone)) && (
                                                    <div className="login-error">
                                                        <Label title={errors.phone?.message || "Please Enter Phone."} modeError={true} />
                                                    </div>
                                                )}
                                        </div>
                                    )}
                                />

                                {/* Project */}
                                <Controller
                                    control={control}
                                    name="projects_id"
                                    rules={{ required: "Please Select Project" }}
                                    render={({ field: { onChange, onBlur }, fieldState: { isTouched } }) => (
                                        <div className="mb-2">
                                            <Form.Label>Project</Form.Label>
                                            <div className="input-group mb-1">
                                                <Select
                                                    className="basic-single w-100"
                                                    classNamePrefix="select"
                                                    isSearchable={true}
                                                    options={projectOptions}
                                                    isMulti={true}
                                                    onChange={(e: any) => { onChange(e) }}
                                                    value={watchAllFields.projects_id}
                                                    placeholder="Select Project"
                                                />
                                            </div>
                                            {(errors["projects_id"]?.message ||
                                                Boolean(errors["projects_id"]?.message) ||
                                                (isTouched && !watchAllFields.projects_id)) && (
                                                    <div className="login-error">
                                                        <Label title={errors.projects_id?.message || "Please Select Project."} modeError={true} />
                                                    </div>
                                                )}
                                        </div>
                                    )}
                                />

                                {/* Role */}
                                <Controller
                                    control={control}
                                    name="role"
                                    rules={{ required: "Please Select Role" }}
                                    render={({ field: { onChange, onBlur }, fieldState: { isTouched } }) => (
                                        <div className="mb-2">
                                            <div className="d-flex align-items-center justify-content-between">
                                                <div>
                                                    <Form.Label>Role</Form.Label>
                                                    <span className="text-danger">*</span>
                                                </div>
                                                <Link to={"#"} onClick={() => { navigate(routePaths.ROLE.path) }} className="font-14">Add Role</Link>
                                            </div>
                                            <div className="input-group mb-1">
                                                <Select
                                                    className="basic-single w-100"
                                                    classNamePrefix="select"
                                                    isSearchable={true}
                                                    options={roleOptions}
                                                    onChange={(e: any) => { onChange(e.value) }}
                                                    value={roleOptions.find((c) => c.value === watchAllFields.role)}
                                                    placeholder="Select Role"
                                                />
                                            </div>
                                            {(errors["role"]?.message ||
                                                Boolean(errors["role"]?.message) ||
                                                (isTouched && !watchAllFields.role)) && (
                                                    <div className="login-error">
                                                        <Label title={errors.role?.message || "Please Select Role."} modeError={true} />
                                                    </div>
                                                )}
                                        </div>
                                    )}
                                />

                                {!isEdit && <>
                                    {/* Password */}
                                    <Controller
                                        control={control}
                                        name="password"
                                        rules={{
                                            required: "Please Enter Password",
                                            pattern: {
                                                value: passwordRegex,
                                                message: "Between 8 to 20 characters and at least one upper case, lower case, number and special character.",
                                            },
                                        }}
                                        render={({ field: { onChange, onBlur }, fieldState: { isTouched } }) => (
                                            <div className="mb-2">
                                                <Form.Label> Password</Form.Label>
                                                <div className="input-group mb-2">
                                                    <input
                                                        type={isShowNewPassword ? "text" : "password"}
                                                        className="form-control border-end-0"
                                                        placeholder="Password"
                                                        onChange={onChange}
                                                        onBlur={onBlur}
                                                    />
                                                    <span
                                                        className="input-group-text text-secondary bg-white border-start-0 cursor-pointer"
                                                        onClick={() => setIsShowNewPassword(!isShowNewPassword)}
                                                    >
                                                        {isShowNewPassword ? (
                                                            <BsEyeSlash size={16} />
                                                        ) : (
                                                            <BsEye size={16} />
                                                        )}
                                                    </span>
                                                </div>
                                                {(errors["password"]?.message ||
                                                    Boolean(errors["password"]?.message) ||
                                                    (isTouched && !watchAllFields.password) ||
                                                    (watchAllFields.password &&
                                                        !passwordRegex.test(watchAllFields.password))) && (
                                                        <div className="login-error">
                                                            <Label
                                                                title={
                                                                    errors.password?.message || watchAllFields.password
                                                                        ? "Between 8 to 20 characters and at least one upper case, lower case, number and special character."
                                                                        : "Please Enter Password."
                                                                }
                                                                modeError={true}
                                                            />
                                                        </div>
                                                    )}
                                            </div>
                                        )}
                                    />

                                    {/* Confirm Password */}
                                    <Controller
                                        control={control}
                                        name="comfirm_password"
                                        rules={{
                                            required: "Please Enter Password",
                                            validate: (value: any) => {
                                                const { password } = getValues();
                                                return password === value || "Passwords must match";
                                            },
                                        }}
                                        render={({
                                            field: { onChange, onBlur },
                                            fieldState: { isTouched },
                                        }) => (
                                            <div className="mb-3">
                                                <Form.Label>Confirm Password</Form.Label>
                                                <div className="input-group mb-2">
                                                    <input
                                                        type={isShowConfirmPassword ? "text" : "password"}
                                                        className="form-control border-end-0"
                                                        placeholder="Confirm Password"
                                                        onChange={onChange}
                                                        onBlur={onBlur}
                                                    />
                                                    <span
                                                        className="input-group-text text-secondary bg-white border-start-0 cursor-pointer"
                                                        onClick={() =>
                                                            setIsShowConfirmPassword(!isShowConfirmPassword)
                                                        }
                                                    >
                                                        {isShowConfirmPassword ? (
                                                            <BsEyeSlash size={16} />
                                                        ) : (
                                                            <BsEye size={16} />
                                                        )}
                                                    </span>
                                                </div>
                                                {(errors["comfirm_password"]?.message ||
                                                    Boolean(errors["comfirm_password"]?.message) ||
                                                    (isTouched && !watchAllFields.comfirm_password) ||
                                                    (watchAllFields.comfirm_password &&
                                                        watchAllFields.password !=
                                                        watchAllFields.comfirm_password)) && (
                                                        <div className="login-error">
                                                            <Label
                                                                title={
                                                                    errors.comfirm_password?.message ||
                                                                        watchAllFields.comfirm_password
                                                                        ? "Passwords Must Match"
                                                                        : "Please Enter Confirm Password."
                                                                }
                                                                modeError={true}
                                                            />
                                                        </div>
                                                    )}
                                            </div>
                                        )}
                                    />
                                </>}
                            </Col>

                        </Row>
                        <div className="text-center border-top">
                            <Button
                                variant="dark"
                                className="btn-brand-1 px-5 mt-3 mb-3 me-2"
                                type="submit"
                                id="changePassword-btn"
                            >
                                {isEdit ? "Update" : "Add"}
                            </Button>
                            <Button
                                variant="light"
                                className="btn-brand-1 px-5 mt-3 mb-3"
                                type="button"
                                onClick={() => closeModal(false)}
                            >
                                Close
                            </Button>
                        </div>
                    </form>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
};

export default AddUser;
